import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7c7c9b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "onKeydown"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-location-dot",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "yt-search__loc-badge",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "yt-search__chips" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "yt-search__chip-label" }
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-xmark",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "yt-search__loc-placeholder"
}
const _hoisted_11 = { class: "yt-loc-panel__head" }
const _hoisted_12 = { class: "yt-loc-panel__title" }
const _hoisted_13 = { class: "yt-loc-panel__count" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-xmark",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "yt-loc-panel__search" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-magnifying-glass",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "yt-loc-panel__meta" }
const _hoisted_21 = {
  key: 0,
  class: "yt-loc-panel__hint"
}
const _hoisted_22 = {
  key: 1,
  class: "yt-loc-panel__hint yt-loc-panel__hint--muted"
}
const _hoisted_23 = { class: "yt-loc-panel__list" }
const _hoisted_24 = ["onMouseenter"]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "fa-solid fa-check"
}
const _hoisted_27 = { class: "yt-loc-panel__item-text" }
const _hoisted_28 = { class: "yt-loc-panel__item-label" }
const _hoisted_29 = {
  key: 0,
  class: "yt-loc-panel__item-sub"
}
const _hoisted_30 = ["aria-label", "aria-expanded", "onMouseenter", "onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-chevron-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "yt-loc-panel__empty"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-spinner fa-spin",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "yt-loc-panel__empty"
}
const _hoisted_37 = { class: "yt-loc-panel__title" }
const _hoisted_38 = { class: "yt-loc-panel__count" }
const _hoisted_39 = { class: "yt-loc-panel__search" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-magnifying-glass",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "yt-loc-panel__list yt-loc-sub__list" }
const _hoisted_43 = ["disabled", "onClick"]
const _hoisted_44 = {
  key: 0,
  class: "fa-solid fa-check"
}
const _hoisted_45 = { class: "yt-loc-panel__item-text" }
const _hoisted_46 = { class: "yt-loc-panel__item-label" }
const _hoisted_47 = {
  key: 0,
  class: "yt-loc-panel__empty"
}

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { CONFIG_AREA_LIST } from '@/api/const/config/cache'
import { apiConfigGet } from '@/api/index'

type LocOption = {
  value: string
  label: string
  hasChildren: boolean
  children?: LocOption[]
}

const MAX_LOCATIONS = 3
const SUB_CLOSE_DELAY = 160


export default /*#__PURE__*/_defineComponent({
  __name: 'Location',
  props: {
    "modelValue": { default: () => [] },
    "modelModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(["opened", "closed"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {

const model = _useModel<string[]>(__props, "modelValue")
const emit = __emit

const open = ref(false)
const query = ref('')
const childQuery = ref('')
const loading = ref(false)
const options = ref<LocOption[]>([])
const hoveredId = ref<string | null>(null)
let subCloseTimer: ReturnType<typeof setTimeout> | null = null

const normalize = (str: string) =>
  (str || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')

const mapNode = (item: any): LocOption | null => {
  const value = item?.id ?? item?.code ?? item?.value
  const label = item?.name ?? item?.label
  if (value == null || !label) return null
  const rawChildren = Array.isArray(item?.children) ? item.children : []
  const children = rawChildren
    .map(mapNode)
    .filter(Boolean) as LocOption[]
  return {
    value: String(value),
    label: String(label),
    hasChildren: children.length > 0,
    children,
  }
}

const parseAreaList = (raw: unknown): LocOption[] => {
  let payload: any = raw
  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload || '[]')
    } catch {
      return []
    }
  }

  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.body)
      ? payload.body
      : Array.isArray(payload?.data)
        ? payload.data
        : []

  return list.map(mapNode).filter(Boolean) as LocOption[]
}

const loadAreas = async () => {
  if (options.value.length || loading.value) return
  loading.value = true
  try {
    const res: any = await apiConfigGet(CONFIG_AREA_LIST)
    const raw = res?.data?.data ?? res?.data
    options.value = parseAreaList(raw)
  } catch {
    options.value = []
  } finally {
    loading.value = false
  }
}

const optionMap = computed(() => {
  const map = new Map<string, LocOption>()
  for (const opt of options.value) {
    map.set(opt.value, opt)
    for (const child of opt.children || []) {
      map.set(child.value, child)
    }
  }
  return map
})

const selectedItems = computed(() =>
  model.value
    .map((value) => optionMap.value.get(value))
    .filter(Boolean) as LocOption[],
)

const matchLabel = (label: string, q: string) => normalize(label).includes(q)

const provinceMatchesQuery = (opt: LocOption, q: string) => {
  if (matchLabel(opt.label, q)) return true
  return (opt.children || []).some((c) => matchLabel(c.label, q))
}

const filtered = computed(() => {
  const q = normalize(query.value.trim())
  if (!q) return options.value
  return options.value.filter((o) => provinceMatchesQuery(o, q))
})

const activeParent = computed(
  () => options.value.find((o) => o.value === hoveredId.value) || null,
)

const filteredChildren = computed(() => {
  const children = activeParent.value?.children || []
  // Prefer child panel search; fall back to main query for live cross-search
  const raw = childQuery.value.trim() || query.value.trim()
  const q = normalize(raw)
  if (!q) return children
  return children.filter((c) => matchLabel(c.label, q))
})

const isMaxed = computed(() => model.value.length >= MAX_LOCATIONS)
const isSelected = (value: string) => model.value.includes(value)

const cancelCloseSub = () => {
  if (subCloseTimer) {
    clearTimeout(subCloseTimer)
    subCloseTimer = null
  }
}

const scheduleCloseSub = () => {
  cancelCloseSub()
  subCloseTimer = setTimeout(() => {
    hoveredId.value = null
    childQuery.value = ''
  }, SUB_CLOSE_DELAY)
}

const openSub = (opt: LocOption) => {
  if (!opt.hasChildren) return
  cancelCloseSub()
  if (hoveredId.value !== opt.value) {
    childQuery.value = ''
  }
  hoveredId.value = opt.value
}

const onRowEnter = (opt: LocOption) => {
  if (hoveredId.value && opt.value !== hoveredId.value && !opt.hasChildren) {
    scheduleCloseSub()
  }
}

/** Live search: when typing matches a district, open that province submenu immediately */
const syncSubFromQuery = () => {
  const raw = query.value.trim()
  const q = normalize(raw)
  if (!q) return

  const parentHit = options.value.find((o) => matchLabel(o.label, q))
  if (parentHit) {
    // Province name match — keep submenu closed unless already browsing children
    return
  }

  const childHit = options.value.find((o) =>
    (o.children || []).some((c) => matchLabel(c.label, q)),
  )
  if (childHit) {
    cancelCloseSub()
    hoveredId.value = childHit.value
    childQuery.value = raw
  }
}

const toggle = () => {
  open.value = !open.value
  if (open.value) {
    query.value = ''
    childQuery.value = ''
    hoveredId.value = null
    emit('opened')
    loadAreas()
  } else {
    hoveredId.value = null
    childQuery.value = ''
    emit('closed')
  }
}

const close = () => {
  if (!open.value) return
  open.value = false
  query.value = ''
  childQuery.value = ''
  hoveredId.value = null
  emit('closed')
}

const toggleValue = (value: string) => {
  if (isSelected(value)) {
    model.value = model.value.filter((v) => v !== value)
    return
  }
  if (isMaxed.value) return
  model.value = [...model.value, value]
}

const clear = () => {
  model.value = []
}

const remove = (value: string) => {
  model.value = model.value.filter((v) => v !== value)
}

watch(query, () => {
  syncSubFromQuery()
  if (
    hoveredId.value &&
    !filtered.value.some((o) => o.value === hoveredId.value)
  ) {
    hoveredId.value = null
    childQuery.value = ''
  }
})

onMounted(() => {
  loadAreas()
})

onBeforeUnmount(() => {
  cancelCloseSub()
})

__expose({ close, open })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["yt-search__loc", { 'is-open': open.value, 'is-has-value': model.value.length }]),
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["yt-search__location", { 'is-open': open.value }]),
      role: "button",
      tabindex: "0",
      "aria-expanded": open.value,
      onClick: toggle,
      onKeydown: [
        _withKeys(_withModifiers(toggle, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(toggle, ["prevent"]), ["space"])
      ]
    }, [
      _hoisted_2,
      (model.value.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(model.value.length), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item) => {
          return (_openBlock(), _createElementBlock("span", {
            key: item.value,
            class: "yt-search__chip",
            title: item.label
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
            _createElementVNode("button", {
              type: "button",
              class: "yt-search__chip-remove",
              "aria-label": _ctx.$t('home.remove'),
              onClick: _withModifiers(($event: any) => (remove(item.value)), ["stop"])
            }, _hoisted_9, 8, _hoisted_7)
          ], 8, _hoisted_5))
        }), 128)),
        (!selectedItems.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('home.locationPlaceholder')), 1))
          : _createCommentVNode("", true)
      ])
    ], 42, _hoisted_1),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "yt-loc-backdrop",
          "aria-hidden": "true",
          onClick: close
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "yt-loc-panel",
      onMouseleave: scheduleCloseSub
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$t('home.locationTitle')) + " ", 1),
          _createElementVNode("span", _hoisted_13, "(" + _toDisplayString(filtered.value.length) + ")", 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "yt-loc-panel__close",
          "aria-label": _ctx.$t('header.close'),
          onClick: close
        }, _hoisted_16, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          type: "search",
          class: "yt-loc-panel__search-input",
          placeholder: _ctx.$t('home.locationSearch'),
          autocomplete: "off"
        }, null, 8, _hoisted_19), [
          [_vModelText, query.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (isMaxed.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('home.locationMaxSelected')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('home.locationSelectHint', { max: MAX_LOCATIONS })), 1)),
        (model.value.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "yt-loc-panel__clear",
              onClick: clear
            }, _toDisplayString(_ctx.$t('home.locationClearAll')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["yt-loc-panel__body", { 'is-sub-open': !!activeParent.value }])
      }, [
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (opt) => {
            return (_openBlock(), _createElementBlock("div", {
              key: opt.value,
              class: _normalizeClass(["yt-loc-panel__row", { 'is-active': hoveredId.value === opt.value }]),
              onMouseenter: ($event: any) => (onRowEnter(opt))
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["yt-loc-panel__item", {
                'is-checked': isSelected(opt.value),
                'is-disabled': !isSelected(opt.value) && isMaxed.value,
              }]),
                disabled: !isSelected(opt.value) && isMaxed.value,
                onClick: ($event: any) => (toggleValue(opt.value))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["yt-loc-panel__check", { 'is-checked': isSelected(opt.value) }]),
                  "aria-hidden": "true"
                }, [
                  (isSelected(opt.value))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(opt.label), 1),
                  (opt.hasChildren)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('home.locationAllDistricts')), 1))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_25),
              (opt.hasChildren)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["yt-loc-panel__submenu-btn", { 'is-open': hoveredId.value === opt.value }]),
                    "aria-label": opt.label,
                    "aria-expanded": hoveredId.value === opt.value,
                    onMouseenter: ($event: any) => (openSub(opt)),
                    onClick: _withModifiers(($event: any) => (openSub(opt)), ["stop","prevent"])
                  }, _hoisted_32, 42, _hoisted_30))
                : _createCommentVNode("", true)
            ], 42, _hoisted_24))
          }), 128)),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
            : (!filtered.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t('home.noSuggest')), 1))
              : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "yt-loc-sub",
          onMouseenter: cancelCloseSub,
          onMouseleave: scheduleCloseSub
        }, [
          _createElementVNode("div", _hoisted_37, [
            _createTextVNode(_toDisplayString(activeParent.value?.label) + " ", 1),
            _createElementVNode("span", _hoisted_38, "(" + _toDisplayString(filteredChildren.value.length) + ")", 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((childQuery).value = $event)),
              type: "search",
              class: "yt-loc-panel__search-input",
              placeholder: _ctx.$t('home.locationSearch'),
              autocomplete: "off"
            }, null, 8, _hoisted_41), [
              [_vModelText, childQuery.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredChildren.value, (child) => {
              return (_openBlock(), _createElementBlock("button", {
                key: child.value,
                type: "button",
                class: _normalizeClass(["yt-loc-panel__item", {
                'is-checked': isSelected(child.value),
                'is-disabled': !isSelected(child.value) && isMaxed.value,
              }]),
                disabled: !isSelected(child.value) && isMaxed.value,
                onClick: ($event: any) => (toggleValue(child.value))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["yt-loc-panel__check", { 'is-checked': isSelected(child.value) }]),
                  "aria-hidden": "true"
                }, [
                  (isSelected(child.value))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(child.label), 1)
                ])
              ], 10, _hoisted_43))
            }), 128)),
            (!filteredChildren.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.$t('home.noSuggest')), 1))
              : _createCommentVNode("", true)
          ])
        ], 544), [
          [_vShow, activeParent.value]
        ])
      ], 2)
    ], 544), [
      [_vShow, open.value]
    ])
  ], 2))
}
}

})